import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
import LocalizedDatePicker from "../LocalizedDatePicker";

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniAsiakas;

class SkenariointiEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        const data = props.Daatta.filter(function (d) {
            return d.riviAvain === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RiviAvain: data[0].riviAvain,
            SkenaarioNimi: data[0].skenaarioNimi,
            SkenaarioKuvaus: data[0].skenaarioKuvaus,
            Omistaja: data[0].omistaja,
            Alku: dayjs(data[0].alku),
            Loppu: dayjs(data[0].loppu),
            Asetukset: data[0].asetukset,
            Jaettu: data[0].jaettu,
            Created: data[0].created,
            AsiakasAvain: data[0].asiakasAvain,
            asiakkaat: (Object.keys(props.lookupLists.asiakkaat).map((d) => ({ value: d, label: props.lookupLists.asiakkaat[d] })) || [])
        };
    }

    UNSAFE_componentWillMount() {
        iniAsiakas = this.state.asiakkaat.find(({ value }) => value === (this.state.AsiakasAvain || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: this.state.data[0].riviAvain,
            SkenaarioNimi: this.state.data[0].skenaarioNimi,
            SkenaarioKuvaus: this.state.data[0].skenaarioKuvaus,
            Omistaja: this.state.data[0].omistaja,
            Alku: dayjs(this.state.data[0].alku),
            Loppu: dayjs(this.state.data[0].loppu),
            Asetukset: this.state.data[0].asetukset,
            Jaettu: this.state.data[0].jaettu,
            Created: this.state.data[0].created,
            AsiakasAvain: this.state.data[0].asiakasAvain
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            SkenaarioNimi: this.state.SkenaarioNimi,
            SkenaarioKuvaus: this.state.SkenaarioKuvaus,
            Omistaja: this.state.Omistaja,
            Alku: this.state.Alku.format("MM/DD/YYYY 00:00:00"),
            Loppu: this.state.Loppu.format("MM/DD/YYYY 23:59:59"),
            Asetukset: this.state.Asetukset,
            Jaettu: this.state.Jaettu,
            AsiakasAvain: this.state.AsiakasAvain
        });
        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    handleChangeDate = (name, value) => {
        this.setState({
            [name]: value,
            jotainMuuttui: true
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, asiakkaat } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Simulation.Skenaario.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniAsiakas}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'AsiakasAvain')}
                                options={asiakkaat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Simulation.Skenaario.Columns[4]} />}
                            />
                        </Box>

                        <TextField
                            margin="dense"
                            id="SkenaarioNimi"
                            label={dictionary.Simulation.Skenaario.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.SkenaarioNimi}
                            onChange={this.handleChange('SkenaarioNimi')}
                        />
                        <TextField
                            margin="dense"
                            id="SkenaarioKuvaus"
                            label={dictionary.Simulation.Skenaario.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.SkenaarioKuvaus}
                            onChange={this.handleChange('SkenaarioKuvaus')}
                        />
                        <LocalizedDatePicker
                            label={dictionary.Simulation.Skenaario.Columns[5]}
                            value={this.state.Alku}
                            onChange={(newValue) => this.handleChangeDate('Alku', newValue)}
                        />
                        <LocalizedDatePicker
                            label={dictionary.Simulation.Skenaario.Columns[6]}
                            value={this.state.Loppu}
                            onChange={(newValue) => this.handleChangeDate('Loppu', newValue)}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "SkenariointiEdit" })(SkenariointiEdit);
